/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import '../config';
import React from 'react';
import moment from 'moment';
import {
  addHours,
  format as Format,
  isValid,
  startOfMonth as StartOfMonth,
  endOfMonth as EndOfMonth,
  startOfYear as StartOfYear,
  endOfYear as EndOfYear,
  add,
  parse,
} from 'date-fns';

import 'moment/locale/pt-br';
import Tooltip from '@material-ui/core/Tooltip';

const validateDate = (date) => {
  return date ? new Date(date) : new Date();
};

const format = (dateString) => {
  const date = validateDate(dateString);
  return Format(date, 'yyyy-MM-dd');
};

const toPrice = (val = null, minimum = null, maximum = null) => {
  const min = minimum || minimum === 0 ? minimum : 2;

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: min,
    maximumFractionDigits: maximum || minimum || 2,
  }).format(Number(val));
};

const toPriceWhole = (val = null) => {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number(val));
};

const toNumber = (val = '0') => {
  if (typeof val === 'number') return val;
  if (typeof val !== 'string') return 0;
  const valor = val.replace(/[.]/g, '').replace(/,/g, '.');
  const parsed = Number(valor);
  return Number.isNaN(parsed) ? 0 : parsed;
};

/** Converte valor da API (string "60.00" ou "60,00") para número. Trata null/undefined. */
const parseDecimal = (val) => {
  if (val === null || val === undefined || val === '') return 0;
  if (typeof val === 'number') return Number.isNaN(val) ? 0 : val;
  const s = String(val).trim().replace(',', '.');
  const n = Number(s);
  return Number.isNaN(n) ? 0 : n;
};

const parseNumberOrNull = (v) => {
  if (v == null || v === '') return null;
  const n = Number(String(v).trim().replace(',', '.'));
  return Number.isNaN(n) ? null : n;
};

const toPrice2 = (val = null) =>
  new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(
    Number(val).toFixed(2),
  );

const toPriceValue = (val) =>
  new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 0 }).format(
    Number(val),
  );

const formatValor = (val) => val.toLocaleString('pt-br');

const safraConverter = (data) => {
  const inicio = data.inicio
    ? moment(data.inicio).format('YYYY')
    : moment().format('YYYY');
  const fim = data.fim
    ? moment(data.fim).format('YYYY')
    : moment().format('YYYY');
  const description = `SAFRA ${inicio}/${fim}`;
  return description;
};

const currencyRS = (value) => {
  if (!Number(value)) return '';

  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value / 100);

  return `${amount}`;
};

const parseCurrency = (value) => {
  if (!value) return 0;

  const stringValue = value.toString();

  const clean = stringValue.replace(/[^\d.,-]/g, '');

  const normalized = clean.replace(/\./g, '').replace(',', '.');

  return parseFloat(normalized) || 0;
};

const toPriceInt = (value = 'R$') => {
  if (typeof value === 'number') return value;

  const queryString = value?.indexOf('R$');

  let newValue = 0;

  if (queryString >= 0) {
    const tempValue = value ? value.replace('R$', '') : 0;
    newValue =
      tempValue.length <= 6
        ? parseFloat(tempValue.replace(/,/g, '.')) || 0
        : parseFloat(tempValue.replace('.', '').replace(/,/g, '.')) || 0;
  } else {
    newValue =
      value.length <= 6
        ? parseFloat(value.replace(/,/g, '.')) || 0
        : parseFloat(value.replace('.', '').replace(/,/g, '.')) || 0;
  }

  return newValue || 0;
};

const formatNumber = (value) => {
  return value.toString().replace(/\./g, ',');
};

const formatHour = (value) => {
  return value.toString().replace(/\./g, ',');
};

const toPriceInt2 = (value) => {
  const newValue = value
    ? parseFloat(value.replace(/\./g, '').replace(/\,/g, '.'))
    : 0;
  return newValue;
};

const toPriceRS = (val = 0) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(val).toFixed(2));

const reducedDate = (date) => {
  return moment(date, '').format('DD/MM/YYYY').substr(0, 7);
};

const formatSizeUnits = (bytesParam) => {
  let bytes = bytesParam;

  if (bytes >= 1073741824) {
    bytes = `${(bytes / 1073741824).toFixed(2)} GB`;
  } else if (bytes >= 1048576) {
    bytes = `${(bytes / 1048576).toFixed(2)} MB`;
  } else if (bytes >= 1024) {
    bytes = `${(bytes / 1024).toFixed(2)} KB`;
  } else if (bytes > 1) {
    bytes += ' bytes';
  } else if (bytes === 1) {
    bytes += ' byte';
  } else {
    bytes = '0 bytes';
  }
  return bytes;
};

const formatDate = (dateStringParam, _format) => {
  if (!dateStringParam) return '';

  let processedDateString = dateStringParam;
  if (processedDateString.includes('/')) {
    processedDateString = processedDateString.replaceAll('/', '-');
  }

  const date_format = _format || 'date';

  const formats = {
    date: 'dd/MM/yyyy',
    dateTime: 'dd/MM/yyyy HH:mm:ss',
  }[date_format];

  if (!processedDateString || processedDateString.indexOf('0000') >= 0) {
    return format(new Date(), formats);
  }

  const isDatePTBR = processedDateString.indexOf('/');

  if (isDatePTBR >= 0) return processedDateString.substring(0, 10);

  const date = new Date(processedDateString);

  if (!isValid(date)) {
    return '';
  }

  const dateTimeZone = addHours(date, 3);
  const dateFormat = Format(dateTimeZone, formats);

  return dateFormat;
};

function formatDateInternacional(dateStringParam) {
  if (!dateStringParam) {
    return '';
  }
  const dateFormat = dateStringParam.includes('/')
    ? 'yyyy/MM/dd'
    : 'yyyy-MM-dd';
  const parsedDate = parse(dateStringParam, dateFormat, new Date());

  return isValid(parsedDate) ? format(parsedDate, 'yyyy-MM-dd') : '';
}

const formatToSetDate = (date) => {
  return moment(date, '').format('MM/DD/YYYY');
};

const formatDateMnY = (date) => {
  return moment(date).format('MM-YYYY');
};

const formatToDate = (date) => {
  moment.locale('pt-br');
  return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
};

const toISO = (val) => {
  if (!val) return null;
  const parsed = moment(val, ['YYYY/MM/DD', 'DD/MM/YYYY', 'YYYY-MM-DD'], true);
  if (parsed.isValid()) return parsed.format('YYYY-MM-DD');
  return null;
};

const toPicker = (val) => {
  if (!val) return null;
  const parsed = moment(val, ['YYYY-MM-DD', 'YYYY/MM/DD', 'DD/MM/YYYY'], true);
  if (parsed.isValid()) return parsed.format('YYYY/MM/DD');
  return null;
};

const toDate = (date) => {
  if (date === 'Data inválida') return '';

  moment.locale('pt-br');
  return moment(date).format('YYYY-MM-DD');
};

const toNewDate = (data) => {
  return new Date(
    Date.parse(
      moment(data, 'YYYY-MM-DD').format('ddd MMM DD YYYY HH:mm:ss ZZ'),
    ),
  );
};

const toDateUS = (date) => {
  moment.locale('pt-br');
  return moment(date).format('YYYY/MM/DD');
};

const formatDate2 = (date) => {
  return moment.utc(date).format('DD/MM/YYYY HH:mm');
};

const formatDateToDDMMYY = (dateString) => {
  try {
    const parsedDate = parse(dateString, 'dd/MM/yyyy', new Date());
    return isValid(parsedDate) ? Format(parsedDate, 'dd/MM/yy') : dateString;
  } catch {
    return dateString;
  }
};

const formatDateHour = (dateStringParam) => {
  if (!dateStringParam || dateStringParam.indexOf('0000') >= 0) {
    return format(new Date(), 'dd/MM/yyyy');
  }

  const isDatePTBR = dateStringParam.indexOf('/');

  if (isDatePTBR >= 0) return dateStringParam.substring(0, 10);

  const date = new Date(dateStringParam);

  if (!isValid(date)) {
    return '';
  }

  const dateTimeZone = addHours(date, -3);
  const dateFormat = Format(dateTimeZone, 'dd/MM/yyyy HH:mm');
  return dateFormat;
};

const formatTime = (item) => {
  if (item.tipo === 'Dia') {
    return `${toPrice(item?.dias, 2, 2)} ${item.dias > 1 ? 'dias' : 'dia'}`;
  }

  const rhours = Math.floor(item.horas);
  const minutes = item?.minutos || Math.round((item.horas - rhours) * 60);

  return `${rhours}h ${minutes}m`;
};

const formatHours = (horas, minutos) => {
  const totalHoras = horas + Math.floor(minutos / 60);
  const totalMinutos = minutos % 60;

  return `${totalHoras} H ${totalMinutos} min`;
};

const formatDays = (dias) => {
  return `${toPrice(dias)} D`;
};

const formatColhido = (value, tipo, medida) => {
  const newValue = tipo === 'Kg' ? value : value * medida;

  return <span>{`${Number(newValue.toFixed(3))} ${tipo}`}</span>;
};

const formatMedida2 = (value, tipo) => {
  return <span>{`${Number(value)} ${tipo}`}</span>;
};

const formatMoneyToInput = (value) => {
  return Number(value) * 100;
};

const formatInputToHook = (value) => {
  return Number(value) / 100;
};

const currencyFormatter = (value, noCurrency) => {
  if (!Number(value)) return '';

  let queryCurrency = {
    currency: 'BRL',
  };

  queryCurrency = Object.assign(queryCurrency, { style: 'currency' });

  const amount = new Intl.NumberFormat('pt-BR', queryCurrency).format(
    value / 100,
  );
  return !noCurrency ? amount : amount.replace('R$', '');
};

const renderTooltip = (value) => (
  <Tooltip style={{ margin: 0, padding: 0 }} title={value} arrow>
    <span className="w-full p-2 overflow-hidden overflow-ellipsis whitespace-nowrap">
      {value}
    </span>
  </Tooltip>
);

function tempoPermanencia({ dataEntrada, dataSaida, horaEntrada, horaSaida }) {
  moment.locale('pt-BR');

  const start = moment(`${dataEntrada} ${horaEntrada}`);
  let end = moment();

  if (dataSaida && horaSaida) {
    end = moment(`${dataSaida} ${horaSaida}`);
  }

  const duration = moment.duration(end.diff(start));

  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();

  const daysFormatted = days ? `${days}D ` : '';
  const hoursFormatted = hours ? `${hours}H ` : '';
  const minutesFormatted = minutes ? `${minutes}M` : '';

  return [daysFormatted, hoursFormatted, minutesFormatted].join('');
}

const startOfMonth = (dateString) => {
  const date = validateDate(dateString);
  const dateTimeZone = addHours(date, 3);
  return Format(StartOfMonth(dateTimeZone), 'yyyy-MM-dd');
};

const endOfMonth = (dateString) => {
  const date = validateDate(dateString);
  const dateTimeZone = addHours(date, 3);
  return Format(EndOfMonth(dateTimeZone), 'yyyy-MM-dd');
};

const startOfYear = (dateString) => {
  const date = validateDate(dateString);
  return Format(StartOfYear(date), 'yyyy-MM-dd');
};

const endOfYear = (dateString) => {
  const date = validateDate(dateString);
  return Format(EndOfYear(date), 'yyyy-MM-dd');
};

const dateAdd = (dateString, tipo) => {
  const date = validateDate(dateString);
  return Format(add(date, tipo), 'yyyy-MM-dd');
};

const dateMonthAdd = (dateString, value) => {
  const date = validateDate(dateString);

  return Format(StartOfMonth(add(date, { months: value })), 'yyyy-MM-dd');
};

const dateMonthSubtract = (dateString, value) => {
  const date = validateDate(dateString);

  return Format(EndOfMonth(add(date, { months: value })), 'yyyy-MM-dd');
};

const formatMedida = (item) => {
  return <span>{`${toPrice(item.quantidade, 3, 3)} ${item.unidade}`}</span>;
};

const dateNow = () => {
  const date = new Date();

  return Format(date, 'yyyy-MM-dd');
};

const formatCnpjCpf = (value) => {
  if (!value) return '';

  const cnpjCpf = value.toString().replace(/\D/g, '');

  if (cnpjCpf.length === 11) {
    return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }

  return cnpjCpf.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
    '$1.$2.$3/$4-$5',
  );
};

const isNegative = (number) => {
  return number < 0;
};

const determineColorPercentage = (percentage, customLimit = 70) => {
  if (!percentage) return '#368467';

  const formatPercentage = toNumber(percentage);

  if (formatPercentage >= 0 && formatPercentage <= customLimit) {
    return '#368467';
  }

  if (formatPercentage > customLimit && formatPercentage <= customLimit + 10) {
    return '#ECCB55';
  }

  return '#FF4848';
};

const codeHashRemover = (value = '') => {
  if (value.includes('-')) {
    return value.split('-')[1];
  }
  return value;
};

const formatToTimeString = (time) => {
  if (!time) return '';

  const timeParts = time.split(':');
  if (timeParts.length !== 3) return '';

  return `${timeParts[0]}:${timeParts[1]}`;
};

const splitList = (val = '') => {
  if (!val || typeof val !== 'string') return [];
  return val.split(', ').map((v) => v.trim());
};

const parseTaraToNumber = (value) => {
  if (value === undefined || value === null || value === '') return 0;

  const clean = String(value)
    .replace(/\s/g, '')
    .replace(',', '.')
    .replace(/[^\d.-]/g, '');

  return parseFloat(clean) || 0;
};

const getProdutoByDescricao = (produtos, descricao) =>
  produtos?.content?.find(
    (p) => p.descricao?.toLowerCase() === descricao.toLowerCase(),
  ) || null;

const calcularTotalLinha = (quantidade, tara) => quantidade * tara;

const calcularSomaCampos = (fields, watchFn, fieldName, parseFn) =>
  fields.reduce((acc, _, index) => {
    const rawValue = watchFn(`simplifiedHarvest[${index}].${fieldName}`) || '0';
    const parsedValue = parseFn(rawValue);

    return acc + (Number.isNaN(parsedValue) ? 0 : parsedValue);
  }, 0);

const toLocalDate = (date) => {
  if (!date) return new Date();
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

const formatDateRobust = (dateString) => {
  if (!dateString) return '';

  try {
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    if (dateString.includes('T')) {
      return dateString.split('T')[0];
    }

    if (dateString.includes('/')) {
      const parts = dateString.split('/');
      if (parts.length === 3) {
        const [day, month, year] = parts;
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }
    }

    const formattedDate = toDate(dateString);
    if (formattedDate && formattedDate !== 'Data inválida') {
      return formattedDate;
    }

    return '';
  } catch (error) {
    return '';
  }
};

const formatDateForDatePicker = (dateString) => {
  if (!dateString) return null;
  return moment(dateString).format('YYYY/MM/DD');
};

const formatValueForInput = (value) => {
  if (value === undefined || value === null) return null;

  const valorString = value.toString();
  const partes = valorString.split('.');
  const parteInteira = partes[0];
  const parteDecimal = partes[1] || '00';

  return `${parteInteira},${parteDecimal.padEnd(2, '0')}`;
};

const parseValueFromFormatted = (formattedValue) => {
  if (!formattedValue) return 0;
  const valorNumerico = Number(
    formattedValue.replace(/[^\d,]/g, '').replace(',', '.'),
  );
  return Number.isNaN(valorNumerico) ? 0 : valorNumerico;
};

const parseDataHora = (dataHora) => {
  if (!dataHora) return new Date(0);

  if (dataHora.includes('T') && dataHora.includes('Z')) {
    return new Date(dataHora);
  }
  if (dataHora.includes(' ')) {
    const isoFormat = dataHora.replace(' ', 'T');
    return new Date(isoFormat);
  }

  return new Date(dataHora);
};

export {
  toNewDate,
  currencyFormatter,
  toPrice,
  toPrice2,
  toPriceValue,
  reducedDate,
  formatDate,
  formatToSetDate,
  formatDate2,
  toPriceRS,
  safraConverter,
  formatTime,
  formatDateHour,
  formatToDate,
  formatHour,
  toPriceInt2,
  toDateUS,
  formatInputToHook,
  formatMedida,
  currencyRS,
  formatColhido,
  formatMedida2,
  toPriceInt,
  toDate,
  formatDateMnY,
  formatValor,
  dateNow,
  formatMoneyToInput,
  renderTooltip,
  tempoPermanencia,
  formatNumber,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  dateAdd,
  dateMonthSubtract,
  dateMonthAdd,
  format,
  toNumber,
  parseDecimal,
  parseNumberOrNull,
  formatSizeUnits,
  formatCnpjCpf,
  isNegative,
  formatDateInternacional,
  determineColorPercentage,
  toPriceWhole,
  formatHours,
  formatDays,
  codeHashRemover,
  formatToTimeString,
  splitList,
  formatDateToDDMMYY,
  parseCurrency,
  parseTaraToNumber,
  getProdutoByDescricao,
  calcularTotalLinha,
  calcularSomaCampos,
  formatDateRobust,
  formatDateForDatePicker,
  formatValueForInput,
  parseValueFromFormatted,
  parseDataHora,
  toISO,
  toPicker,
  toLocalDate,
};
